
import Button from '@/ui-kit/components/button';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ButtonFillType, ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { downloadDataURL } from '@/utils/FileHelper';

export default {
  name: 'DownloadChartButton',
  components: {
    Button,
  },
  props: {
    chartRef: {
      type: Object,
      required: true,
    },
    chartName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Download Graph',
    },
    description: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      ButtonFillType,
      StyleColorSchemeType,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  methods: {
    async onDownload() {
      const { imgURI } = await this.chartRef.dataURI();

      // Create new image with the selected graph
      // And appened the graph title and footer to the final image.
      const img = new Image();
      img.src = imgURI;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width + 20;
        canvas.height = img.height + 160;
        ctx.fillStyle = '#FFF';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#000';
        ctx.font = '19pt sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(this.chartName, canvas.width / 2, 50);
        ctx.drawImage(img, 10, 60);
        ctx.font = '16pt sans-serif';
        if (this.description) {
          ctx.fillText(
            this.description,
            canvas.width / 2,
            canvas.height - 40,
          );
        }
        downloadDataURL(canvas.toDataURL('image/jpeg'), `${this.chartName} Graph.jpeg`);
      };
    },
  },
};
